import type { UseProgramMapResult } from "../useProgramMap.js";
import { ChannelChip } from "./ChannelChip.js";

export type ChannelListEntry = {
  channel: number;
  used: boolean;
  active: boolean;
  noteCount: number;
};

export type ChannelListProps = {
  open: boolean;
  onToggleOpen: () => void;
  /** Каналы 0..15 с признаками used/active и числом нот. */
  channels: ReadonlyArray<ChannelListEntry>;
  /** GM-программа на канал (см. `channelProgram`). */
  programs: ReadonlyMap<number, number>;
  programMap: UseProgramMapResult;
  onToggleChannel: (channel: number) => void;
  onInstrumentChange: (channel: number, program: number) => void;
};

/**
 * Аккордион «Каналы» над piano roll: заголовок-кнопка со сводкой активных
 * каналов + (при открытии) список `ChannelChip` по одному на канал 0..15.
 * Чисто презентационный — стейт (`enabledChannels`, `instrumentOverrides`,
 * открытость) остаётся в `App`.
 */
export const ChannelList = ({
  open,
  onToggleOpen,
  channels,
  programs,
  programMap,
  onToggleChannel,
  onInstrumentChange,
}: ChannelListProps) => {
  const usedCount = channels.filter((c) => c.used).length;
  const activeCount = channels.filter((c) => c.active).length;

  return (
    <div className="pr-channels">
      <button type="button" className="pr-channels__head" onClick={onToggleOpen}>
        <span>
          Каналы
          <span className="muted">
            {" "}
            (активны: {activeCount}/{usedCount})
          </span>
        </span>
        <span>{open ? "▾" : "▸"}</span>
      </button>
      {open ? (
        <div className="pr-channels__chips">
          {channels.map((c) => (
            <ChannelChip
              key={c.channel}
              channel={c.channel}
              used={c.used}
              active={c.active}
              noteCount={c.noteCount}
              program={programs.get(c.channel) ?? 0}
              programMap={programMap}
              onToggle={onToggleChannel}
              onInstrumentChange={onInstrumentChange}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};
